import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const FormView = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='FormView' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,17 C9.27272727,17 6,14.2222222 6,12 C6,9.77777778 9.27272727,7 12,7 C14.7272727,7 18,9.77777778 18,12 C18,14.2222222 14.7272727,17 12,17 Z M11,12 C11,12.55225 11.44775,13 12,13 C12.55225,13 13,12.55225 13,12 C13,11.44775 12.55225,11 12,11 C11.44775,11 11,11.44775 11,12 Z' />
  </StyledIcon>
);
